import {UF} from "./UF";

export type Aula = {
    id: number;
    nom: string;
    hores: number;
    bbdd: number;
    duracio : number;
    cua : number;
    visualitzar : boolean;
    ufs : UF[];
}

export const defaultAula: Aula = {
    id: 0,
    nom: "No hi ha aules per mostrar",
    hores: 0,
    bbdd: 0,
    cua: 0,
    visualitzar: false,
    duracio: 0,
    ufs: []
};
